import styled from 'styled-components';
import { GREEN_600, RED_600 } from '../../../../constants';

const getColor = (positive: boolean, goodWhen: 'positive' | 'negative') => {
    if (positive) {
        return goodWhen === 'positive' ? GREEN_600 : RED_600;
    }
    return goodWhen === 'positive' ? RED_600 : GREEN_600;
};

export const MetricChangeContainer = styled.div<{ $positive: boolean, $goodWhen: 'positive' | 'negative' }>`
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    flex-shrink: 0;
    font-size: 0.875rem;
    line-height: 1rem;
    color: ${({ $positive, $goodWhen }) => getColor($positive, $goodWhen)};
`;

export const MetricChangeIcon = styled.span`
    display: inline-flex;
    align-items: center;
    line-height: 0;

    svg {
        width: 14px;
        height: 14px;
    }
`;
